import { render, staticRenderFns } from "./AppTextEditor.vue?vue&type=template&id=4e05cd8a&scoped=true&"
import script from "./AppTextEditor.vue?vue&type=script&lang=js&"
export * from "./AppTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./AppTextEditor.vue?vue&type=style&index=0&id=4e05cd8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e05cd8a",
  null
  
)

export default component.exports